import { useEffect, useRef } from "react";

// All element types that should trigger the active cursor state
const INTERACTIVE =
  'a, button, input, textarea, select, label, [role="button"], [tabindex]:not([tabindex="-1"])';

const CustomCursor = () => {
  const dotRef  = useRef(null);
  const ringRef = useRef(null);

  useEffect(() => {
    let mouseX = 0, mouseY = 0;
    let ringX  = 0, ringY  = 0;
    let rafId;

    const animate = () => {
      ringX += (mouseX - ringX) * 0.12;
      ringY += (mouseY - ringY) * 0.12;

      // Use translate(-50%,-50%) so the element self-centers at the target
      // coordinate regardless of its current width/height (handles resize on hover)
      if (dotRef.current) {
        dotRef.current.style.transform =
          `translate(${mouseX}px, ${mouseY}px) translate(-50%, -50%)`;
      }
      if (ringRef.current) {
        ringRef.current.style.transform =
          `translate(${ringX}px, ${ringY}px) translate(-50%, -50%)`;
      }

      rafId = requestAnimationFrame(animate);
    };

    const onMouseMove = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
    };

    // Use event delegation — catches all interactive elements including
    // dynamically rendered ones (form steps, FAQ items, etc.)
    const onMouseOver = (e) => {
      if (e.target.closest(INTERACTIVE)) {
        dotRef.current?.classList.add("cursor--active");
        ringRef.current?.classList.add("cursor--active");
      }
    };

    const onMouseOut = (e) => {
      if (e.target.closest(INTERACTIVE)) {
        dotRef.current?.classList.remove("cursor--active");
        ringRef.current?.classList.remove("cursor--active");
      }
    };

    window.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseover", onMouseOver);
    document.addEventListener("mouseout",  onMouseOut);
    rafId = requestAnimationFrame(animate);

    return () => {
      window.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseover", onMouseOver);
      document.removeEventListener("mouseout",  onMouseOut);
      cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <>
      <div ref={dotRef}  className="cursor-dot"  aria-hidden="true" />
      <div ref={ringRef} className="cursor-ring" aria-hidden="true" />
    </>
  );
};

export default CustomCursor;
